import { EVENT_TYPE } from '@/const.js';
import { memo, useMemo } from 'react';
import isEqual from 'react-fast-compare';

const Type = memo(({ type, icon }: { type: string; icon?: string }) => {
  const config = useMemo(
    () => EVENT_TYPE.find((i) => i.value === type),
    [type]
  );

  return (
    <span
      className={
        'flex items-center text-gray-500 text-xs scale-90 origin-left font-[600]'
      }
      style={{
        color: config?.color,
      }}
    >
      <i
        className={`ic-outline text-sm mr-1 ${icon || config?.icon} mt-[0.5px]`}
      />
      {config?.label.replace('活动', '')}
    </span>
  );
}, isEqual);

export default Type;
